/* eslint-disable */
/// This file is auto generated - do not edit manually
export const NoticeHazardLabel = 'Website.Product.HazardLabel.NoticeHazardLabel';
export const SeeHazardLabel = 'Website.Product.HazardLabel.SeeHazardLabel';
